/* eslint-disable quotes */
import { defineComponent, h } from 'vue';
import { Dialog } from '@phi/components';
import { clear_symmetry_plane } from '@frontend/scene';

const body = `<div class='row'>
    <div class='col-sm-12 block-3-box wow fadeInUp'>
        <p class='modal-body-text'>
            Are you sure you want to clear the symmetry? All of the edges you have added in the symmetry sets will be lost.
        <p>
    </div>
</div>`;

export default defineComponent({
    props: {
        show: { required: true, type: Boolean},
    },

    emits: {
        'update:show': (x: boolean) => true,
    },

    render() {
        return h(Dialog, {
            show: this.show,
            'onUpdate:show': x => this.$emit('update:show', x),
            close_label: 'Cancel',
            onClose: () => this.$emit('update:show', false),
            confirm_label: 'Proceed',
            onConfirm: clear_symmetry_plane,
            id: 'proceedWithClearSymmetryModal',
            title: 'Clearing symmetry',
            width: 'narrower',
        }, () => h('div', { innerHTML: body }));
    }
});
